module.exports = __webpack_public_path__ + "media/images/mobile/solutions/29-e6017f5182c86c5cb39cbdc4ff15dfcc.png";